/** Paths under EDGE_PATHS.agent on the preview host. */
export const AGENT_PATHS = {
    events: '/__xb/agent/events',
    message: '/__xb/agent/message',
    stop: '/__xb/agent/stop',
    publish: '/__xb/agent/publish',
    status: '/__xb/agent/status',
    history: '/__xb/agent/history',
};
//# sourceMappingURL=agent-events.js.map